export const categoryList = [{
        id: 1,
        category: "Income Tax Act, 1961"
    },
    {
        id: 2,
        category: "Goods and Services Tax Act, 2017"
    },
    {
        id: 3,
        category:	"Prohibition of Benami Property Transactions Act, 1988"
    },
    {
        id: 4,
        category:	"Black Money (Undisclosed Foreign Income and Assets) and Imposition of Tax Act, 2015"
    },
    {
        id: 5,
        category:	"Fugitive Economic Offenders Act, 2018"
    },
    {
        id: 6,
        category:	"Prevention of Money-Laundering Act, 2002"
    },
    {
        id: 7,
        category:	"Foreign Exchange Management Act, 1999"
    },
    {
        id: 8,
        category:	"Companies Act, 2013"
    },
    {
        id: 9,
        category:	"Any other"
    },
]